import React from 'react';
import styles from './index.module.sass';

const TitleActualizado = (props) => {
  const { title = '', subtitle = '', device = {}, mensaje = '' } = props;
  const { screenSize = 'desktop' } = device;
  return (
    <div id={styles.Titles} className={styles[screenSize]}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <div className={styles.mensaje}>{mensaje}</div>
    </div>
  );
};

export default TitleActualizado;
